import { css } from '../../styled-components';
export const visibleFocus = params => css`
  ${({
  theme
}) => {
  const base = css`
      &:focus-visible {
        outline: ${({
    theme: {
      colors
    }
  }) => colors.brand.highlight[100]} dotted 2px;
        outline-offset: ${params !== null && params !== void 0 && params.noFocusOffset ? '0px' : params !== null && params !== void 0 && params.focusOffset ? params === null || params === void 0 ? void 0 : params.focusOffset : '5px'};
      }
      &:focus:not(.focus-visible) {
        outline: none;
      }
    `;
  switch (theme.themeId) {
    case 'migipedia':
    case 'migipediaDark':
      {
        return css`
          /* stylelint-disable no-descending-specificity */
          &.focus-visible,
          &:focus,
          &:active {
            outline: none !important;
            box-shadow: 0 0 0 2px ${({
          theme
        }) => theme.colors.brand.primary[50]} !important;
          }
          ${base}
        `;
      }
    default:
      {
        return css`
          ${base}
        `;
      }
  }
}}
`;